import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const MoonIcon: React.FC<NormalIconProps> = (props) => (
	<svg
		width="44"
		height="44"
		viewBox="0 0 44 44"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={props.className}
		onClick={props.onClick}
	>
		<g clipPath="url(#clip0_1886_4597)">
			<rect width="44" height="44" rx="22" fill="#005F61" />
			<path
				d="M21.9998 30.3333C26.6023 30.3333 30.3332 26.6025 30.3332 22C30.3332 21.6141 29.7548 21.55 29.5557 21.8808C29.1309 22.5844 28.5515 23.1821 27.8615 23.6287C27.1715 24.0752 26.3889 24.3589 25.573 24.4582C24.7571 24.5575 23.9294 24.4699 23.1524 24.2019C22.3754 23.9339 21.6696 23.4926 21.0884 22.9114C20.5072 22.3302 20.0659 21.6244 19.7979 20.8474C19.5299 20.0704 19.4423 19.2426 19.5416 18.4268C19.6409 17.6109 19.9246 16.8283 20.3711 16.1383C20.8177 15.4483 21.4154 14.8689 22.119 14.4441C22.4498 14.2441 22.3857 13.6666 21.9998 13.6666C17.3973 13.6666 13.6665 17.3975 13.6665 22C13.6665 26.6025 17.3973 30.3333 21.9998 30.3333Z"
				fill="#DBF1FF"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1886_4597">
				<rect width="44" height="44" rx="22" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
